import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicEvents extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <path
        d="M1.59,19a12,12,0,0,0,3-8.07V6.45A6.47,6.47,0,0,1,8.33.8,8.49,8.49,0,0,1,10.05.22h0a8.9,8.9,0,0,1,3.74,0h0a8.84,8.84,0,0,1,1.88.63A6.28,6.28,0,0,1,19.3,6.44v4.49A12.12,12.12,0,0,0,22.41,19Z"/>
      <path d="M12.1,24c-2,0-3.7-1.35-3.7-3H10c0,.86.93,1.56,2.08,1.56s2.08-.7,2.08-1.56h1.61C15.79,22.65,14.13,24,12.1,24Z"/>
    </g>
  ]
  getViewBox = () => '0 0 24 24'
}
